import axios from './index'

export default {
  getPaysByRef(ref, params) {
    return axios.get(`/api/v1/booking/pay/${ref}`, { params })
  },
}